module.exports = __webpack_public_path__ + "images/80c429731c247b3870bf67144a9f6859.png";